import React from 'react';

const BoxLogTableRow = ({ box: { eventId, user, event, createdAt } }) => {
  var now = new Date(createdAt);
  var LocalDate = now.toLocaleDateString();
  var LocalTime = now.toLocaleTimeString();
  return (
    <tr className="row-hover">
      <td>{eventId}</td>
      <td>{user || '-'}</td>
      <td>{event}</td>
      <td>{LocalDate}</td>
      <td>{LocalTime}</td>
    </tr>
  );
};

export default BoxLogTableRow;
